import { Mountain } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BrandLogoProps {
    className?: string;
    size?: number; // Taille de l'icône
    showText?: boolean; // Afficher "TrailBets" ?
    theme?: 'dark' | 'light'; // 'dark' = texte noir (pour fond blanc), 'light' = texte blanc
}

export function BrandLogo({
                              className,
                              size = 32,
                              showText = true,
                              theme = 'dark'
                          }: BrandLogoProps) {
    return (
        <div className={cn("flex items-center gap-2", className)}>
            {/* L'icône dans son carré émeraude (toujours le même style) */}
            <div
                className="bg-emerald-600 rounded-xl flex items-center justify-center shadow-lg shadow-emerald-200 rotate-3 flex-shrink-0"
                style={{ width: size, height: size }}
            >
                <Mountain className="text-white" size={size * 0.6} />
            </div>

            {/* Le Texte (Optionnel) */}
            {showText && (
                <span className={cn(
                    "font-black tracking-tight leading-none",
                    theme === 'dark' ? "text-slate-900" : "text-white"
                )}
                      style={{ fontSize: size * 0.75 }}
                >
          TrailBets
        </span>
            )}
        </div>
    );
}
